// components/CustomSuccessToast.jsx
import React from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import "./CustomToastStyles.css";

const CustomSuccessToast = ({ message, closeToast }) => {
  return (
    <div className="custom-toast success-toast">
      <div className="custom-toast-header">
        <IoMdCheckmarkCircleOutline className="toast-icon" color="white" size={100} />
      </div>
      <div className="custom-toast-body">
        <p className="toast-title">Success</p>
        <p className="py-1">{message || "Your operation was successful."}</p>
        <div className="d-flex justify-content-center mb-4 mt-2">
          <button className="custom-toast-btn" onClick={closeToast}>
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomSuccessToast;
